module.exports = __webpack_public_path__ + "img/guardian.4e6cbd51.svg";